import { ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';
import { NO_HTML_ESCAPING_CHARACTERS_REGEX } from './strings';

export class UtilFunctions {

    // @ts-ignore
    static isInt(n) {
        return !isNaN(n) && n % 1 === 0;
    }
}

// @ts-ignore
export const isUndefinedOrNull = (value) => value === null || typeof value === 'undefined' || value === 'undefined';

// @ts-ignore
export const isObjectEmpty = (obj) => (obj && Object.keys(obj).length === 0 && obj.constructor === Object);

// @ts-ignore
export const genericStringValidator = (inputString) => {
    let message: string = ValidationMessages.VALID;
    const expBlockNonLatinChar = /^[\u0000-\u007F]*$/;

    if (inputString.trim() === ''
    || NO_HTML_ESCAPING_CHARACTERS_REGEX.exec(inputString) == null) {
        message = ValidationMessages.INVALID;
    }
    if (inputString.length > ValidationMessages.MAXIMUM_LENGTH) {
        message = ValidationMessages.EXCEEDS_MAX_LENGTH;
    }
    if (expBlockNonLatinChar.exec(inputString) === null) {
        message = ValidationMessages.NON_LATIN;
    }
    return message;
};

export const getBodyScrollTop = () => {
    const doc = document.documentElement;
    return (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
};

export const setBodyScrollTop = (pixels: number) => {
    // Chrome, Firefox, IE and Opera places the overflow at the <html> level,
    // unless else is specified.
    document.documentElement.scrollTop = pixels;
    document.body.scrollTop = pixels; // safari
};

// @ts-ignore
export const uniqueNumber = (value, index, self) => self.indexOf(value) === index;

export enum ValidationMessages {
    VALID = 'valid',
    INVALID = 'invalid',
    NON_LATIN = 'non-latin',
    EXCEEDS_MAX_LENGTH = 'exceeds-maximum',
    MAXIMUM_LENGTH = 64
}

export const titleCaseWord = (word: string) => {
    if (!word) {
        return word;
    }
    return word[0].toUpperCase() + word.substr(1).toLowerCase();
};

// pure remove key in object
// @ts-ignore
export const remove = (o, k) => Object.keys(o).reduce((ob, ky) => {
    if (!areKeysEqual(k, ky)) {
        ob[ky] = o[ky];
    } return ob;
}, {});
// @ts-ignore
const areKeysEqual = (k, objectKey) => typeof(k) === 'number' ? k === +objectKey : k === objectKey;


export const isObjectArrayEqual = (value, other) => {

    // Get the value type
    const type = Object.prototype.toString.call(value);

    // If the two objects are not the same type, return false
    if (type !== Object.prototype.toString.call(other)) {
        return false;
    };

    // If items are not an object or array, return false
    if (['[object Array]', '[object Object]'].indexOf(type) < 0) {
        return false;
    }

    // Compare the length of the length of the two items
    const valueLen = type === '[object Array]' ? value.length : Object.keys(value).length;
    const otherLen = type === '[object Array]' ? other.length : Object.keys(other).length;
    if (valueLen !== otherLen) {
        return false;
    };

    // Compare two items
    const compare = (item1, item2) => {

        // Get the object type
        const itemType = Object.prototype.toString.call(item1);

        // If an object or array, compare recursively
        if (['[object Array]', '[object Object]'].indexOf(itemType) >= 0) {
            if (!isObjectArrayEqual(item1, item2)) {
                return false;
            };
        } else { // Otherwise, do a simple comparison

            // If the two items are not the same type, return false
            if (itemType !== Object.prototype.toString.call(item2)) {
                return false;
            };

            // Else if it's a function, convert to a string and compare
            // Otherwise, just compare
            if (itemType === '[object Function]') {
                if (item1.toString() !== item2.toString()) {
                    return false;
                };
            } else {
                if (item1 !== item2) {
                    return false;
                };
            }

        }
    };

    // Compare properties
    if (type === '[object Array]') {
        for (let i = 0; i < valueLen; i++) {
            if (compare(value[i], other[i]) === false) {
                return false;
            };
        }
    } else {
        for (const key in value) {
            if (value.hasOwnProperty(key)) {
                if (compare(value[key], other[key]) === false) {
                    return false;
                };
            }
        }
    }

    // If nothing failed, return true
    return true;

};

/* Split array T to chunks
* eg. array: number[] = [1,2,3,4,5,5,7,8,9,12,45], chunk_size = 3
* arrayChunks(array, chunck_size) -> [[1,2,3],[4,5,5],[7,8,9],[12,45]]
*/
export const arrayChunks = <T>(array: T[], chunk_size: number) => Array(Math.ceil(array.length / chunk_size))
    .fill(null)
    .map((_, index) => index * chunk_size)
    .map(begin => array.slice(begin, begin + chunk_size));
